/** @jsx jsx */
import { Box, jsx, Grid } from "theme-ui";
import { StaticImage } from "gatsby-plugin-image";
import { PageContentNonMemoized } from "gatsby-plugin-hfn-profile/components/PageContentNonMemoized";
import React, { useCallback } from "react";
import banner from "../../static/imgs/kanha-celebration-bgimg.jpg";
import LayoutHome from "../layout/LayoutHome";
import { eventCallbackTriggers } from "../templates/wppage";

const KanhaAshramInaugurationFundSmall = () => {
  const pageContent = (id, modalTitle) => {
    const titletext = modalTitle || "Donation for Corpus Fund";
    return `<gatsby_donation donationId = "${id}" btntext = "${titletext}" btnBg = #4d8f15 colortext = black colorprimary = forestgreen colorsecondary = darkgreen colorbackground = white colormuted = #f6f6f6 colorhighlight = #efeffe titletext = "Kanha Ashram Inaugration Fund" allowOverseas = false/>`;
  };

  const PageContent = React.memo(PageContentNonMemoized);

  const eventCallback = useCallback(
    (event) => eventCallbackTriggers("kanha_ashram_inaugration_fund", event),
    []
  );
  const renderContentHeader = () => (
    <Box
      sx={{
        marginBottom: "2rem",
        paddingTop: "30px",
        alignItems: "center",
        minHeight: "38px",
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundImage: `url(${banner})`,
      }}
    >
      <Box sx={{ paddingBottom: "30px" }}>
        <h3
          sx={{
            color: "White",
            marginTop: "35px",
            fontWeight: "400",
            marginBottom: "1rem",

            textAlign: "center!important",
            fontSize: "1.7rem",
          }}
        >
          Heartfulness Donations
        </h3>
        <h2
          sx={{
            color: "#e2aa00",
            fontWeight: "450",
            lineHeight: "1.2",
            marginBottom: "1rem",
            textAlign: "center!important",
          }}
        >
          <b>Kanha Ashram Inauguration Fund – Diamond Jubilee</b>
        </h2>
        <div
          className="test"
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "40px",
          }}
        >
          <StaticImage
            src="../../static/imgs/years-celebrations-icon.png"
            alt="Logo"
            sx={{
              maxHeight: "170px",
              maxWidth: "171px",
            }}
          />
        </div>
      </Box>
    </Box>
  );

  return (
    <LayoutHome
      contentHeader={renderContentHeader()}
      seoTitle="Kanha Ashram Inauguration fund - Small - Donations"
    >
      <Grid>
        <Box>
          <p style={{ textAlign: "justify" }}>
            <b>Welcome!</b> Thank you for choosing to donate to Kanha
            Inauguration Fund of Sahaj Marg Spirituality Foundation, India which
            has been setup specifically to cover large expenses in Kanha
            Shantivanam — Construction of meditation hall complex, additional
            accommodations & other facilities, hosting 80,000 visitors during
            the Kanha Inauguration function — and various initiatives for
            expansion of Heartfulness Movement in 2020.
          </p>
          <p style={{ textAlign: "justify" }}>
            Please make one or more selections from the options below. You may
            also choose all the options by selecting “All of the above”. On
            completion of the donation, a confirmation email will be sent to you
            with a completed donation form attached.{" "}
            <b>There are no refunds for the donations.</b>
          </p>
        </Box>
        <Box>
          <PageContent
            eventCallback={eventCallback}
            pageContent={pageContent(1, "Contribute Now")}
          />
        </Box>
      </Grid>
    </LayoutHome>
  );
};

export default KanhaAshramInaugurationFundSmall;
